/* eslint-disable */
import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';

import AbstractSearchController from '@/js/desktop/Domain/Abstract/SearchController';
import SearchPageView from '@/js/desktop/View/SearchPage';
import SearchFormAutocompleteView from '@/js/desktop/components/searchFormAutocomplete/SearchFormAutocomplete';

import '@/css/desktop/search';
import '@/css/desktop/search/destination-info-atlas.css';

var Controller = AbstractSearchController.extend({ //toDo добавить переменную searchFormSearchType
	storeCriteria: function() {},
	initPriceCalendar: () => {},
	initSearchForm: function () {
		this.searchFormView = new SearchFormAutocompleteView({
			pageType: 'ski'
		});
	},
	modifyTourCriteria: function(tourCriteria) {
		var country = tourCriteria.get('countries').at(0);

		if(tourCriteria.get('resorts') && !tourCriteria.get('resorts').length) {
			tourCriteria = tourCriteria.clone();
			tourCriteria.set('resorts', country.get('resorts'));
		}
		return tourCriteria;
	},
	initSearchPageView: function () {
		this.view = new SearchPageView({
            el: '#forSearchView',
            searchFormViewModel: this.model,
            dataLayerAnalytics: this.dataLayerAnalytics,
			namePage: 'ski',
		})
	},
	initialize: function() {
		AbstractSearchController.prototype.initialize.call(this);
	}
});

$(() => {
    const searchController = new Controller({
        el: 'body',
    });

	 searchController.initSearchOnScroll();
});
